import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=4037c50b&scoped=true"
import script from "./forms.vue?vue&type=script&lang=js"
export * from "./forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037c50b",
  null
  
)

export default component.exports